import jsPDF from "jspdf";
import "jspdf-autotable";
import * as style from './ReportStyle';
import * as table from './TableData';
import { date_dmy_func } from "../../../../components/Common/CommonFunction";

var pageHeder = function (doc, dateRange) {
    style.pageBorder(doc);
    style.pageHeder(doc);
    style.reportHeder1(doc, dateRange);
};

function reportBody(doc, data, dateRange) {
    style.tableBody(doc, data, dateRange);
}

function pageFooter(doc) {
    style.pageFooter(doc);
}

const WastageReport1 = (responseData) => {
    const items = Array.isArray(responseData) ? responseData : (responseData?.Data || []);
    const data = { Data: items };

    let dateRange = {};
    try {
        dateRange = JSON.parse(sessionStorage.getItem("WastageReportDateRange")) || {};
    } catch (e) { }
    if (!dateRange.fromDate && !dateRange.toDate) {
        dateRange = table.getDateRange(items);
    }

    // ⭐ portrait A4 — 'p' instead of 'l', matching Scheme exactly
    var doc = new jsPDF('p', 'pt', 'a4');

    pageHeder(doc, dateRange);
    reportBody(doc, data, dateRange);
    pageFooter(doc);

    doc.setProperties({
        title: `Wastage_Report${dateRange.fromDate ? `_From_${date_dmy_func(dateRange.fromDate)}` : ""}${dateRange.toDate ? `_To_${date_dmy_func(dateRange.toDate)}` : ""}`,
    });

    function generateSaveAndOpenPDFReport() {
        const pdfUrl = URL.createObjectURL(doc.output('blob'));
        window.open(pdfUrl);
    }
    generateSaveAndOpenPDFReport();
};

export default WastageReport1;